/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import * as React from 'react';
import { createDefaultMarket } from 'src/config/default';

export interface Market {
  marketId: string;
  asset: MarketAsset;
  copy: MarketCopy;
  featureFlags: MarketFeatures;
  memberInsurance?: InsuranceCardConfig[];
  nonMemberInsurance?: { [index: string]: string };
}

export const MarketContext = React.createContext(createDefaultMarket);

export type MarketCopy = { [index: string]: any };

export interface MarketFeatures {
  landing?: {
    callToAction?: boolean;
    howQuartetWorks?: boolean;
    mentalHealth?: boolean;
  };

  selfReferral?: {
    insurance?: boolean;
    yourself?: boolean;
    call?: boolean;
    nonMember?: boolean;
    defaultState?: string;
  };
}

export interface InsuranceCardConfig {
  id: string;
  title: string;
  titleColor: string;
  subTitle: string;
  fullPlanName: string;
  eventName: string;
  flag?: string;
}

export interface MarketAsset {
  landing?: {
    heroSm?: '*.png';
    heroSmWebp?: '*.webp';
    heroMd?: '*.png';
    heroMdWebp?: '*.webp';
    heroLg?: '*.png';
    heroLgWebp?: '*.webp';
    testimonial?: '*.png';
    testimonialWebp?: '*.webp';
    values?: '*.png';
    valuesWebp?: '*.webp';
    valuesBlob?: '*.png';
    valuesBlobWebp?: '*.webp';
    valuesSm?: '*.png';
    valuesSmWebp?: '*.webp';
    valuesMd?: '*.png';
    valuesMdWebp?: '*.webp';
    valuesLg?: '*.png';
    valuesLgWebp?: '*.webp';
    expect1lg?: '*.png';
    expect1lgWebp?: '*.webp';
    expect1sm?: '*.png';
    expect1smWebp?: '*.webp';
    expect2lg?: '*.png';
    expect2lgWebp?: '*.webp';
    expect2sm?: '*.png';
    expect2smWebp?: '*.webp';
    expect3lg?: '*.png';
    expect3lgWebp?: '*.webp';
    expect3sm?: '*.png';
    expect3smWebp?: '*.webp';
  };
}
